import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-slate-900 text-white py-16 px-4" data-id="element-89">
      <div className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-90">
        <ShieldCheckIcon className="w-20 h-20 text-blue-400 mb-6" data-id="element-91" />
        <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-92">
          Garantía de Satisfacción de 30 Días
        </h2>
        <p className="text-lg md:text-xl text-slate-300 leading-relaxed" data-id="element-93">
          Estamos tan seguros de que nuestra Rodillera Térmica USB te ayudará a
          aliviar el dolor, que te ofrecemos una garantía de 30 días. Si no
          estás 100% satisfecho con los resultados, te devolvemos tu dinero. Sin
          preguntas, sin complicaciones.
        </p>
      </div>
    </section>;
}